<template>
  <footer class="pfoot">
    <div class="pfoot-grid">
      <div class="pfoot-about">
        <p class="pfoot-name">Gestionnaire Citron</p>
        <p class="pfoot-pitch">Devis, factures, facturation électronique, achats et export comptable pour les TPE et les indépendants. Créé et maintenu par Franck Besson, à Toulouse.</p>
      </div>

      <nav aria-label="Le gestionnaire">
        <h2>Le gestionnaire</h2>
        <ul>
          <li><router-link to="/tarification">Tarif</router-link></li>
          <li><router-link to="/who">Informations</router-link></li>
          <li><router-link to="/assistance">Assistance</router-link></li>
          <li><router-link to="/legal">Légal</router-link></li>
        </ul>
      </nav>

      <nav aria-label="Le site Citron Digital">
        <h2>Citron Digital</h2>
        <ul>
          <li><a :href="siteUrl">Retour au site</a></li>
          <li><a :href="productUrl">Présenter le logiciel</a></li>
          <li><a :href="contactUrl">Contact</a></li>
        </ul>
      </nav>
    </div>

    <div class="pfoot-legal">
      <p><i class="icon fas fa-copyright"></i> {{ year }} Copyright</p>
      <p>Made with pep<span class="peps">s</span> by <a :href="siteUrl">Citron Digital</a></p>
    </div>
  </footer>
</template>

<script>
  import {library} from '@fortawesome/fontawesome-svg-core';
  import {faCopyright} from "@fortawesome/free-solid-svg-icons";
  import {SITE_URL, SITE_PRODUCT_URL, SITE_CONTACT_URL} from "@/components/public/siteLinks";
  library.add(faCopyright);

  /**
   * Pied de page des pages hors connexion : mêmes liens que le pied de page de l'application (légal, informations, tarif, assistance),
   * avec le retour vers le site.
   */
  export default {
    name: 'PublicFooter',
    data() {
      return {
        year: new Date().getFullYear(),
        siteUrl: SITE_URL,
        productUrl: SITE_PRODUCT_URL,
        contactUrl: SITE_CONTACT_URL,
      }
    }
  }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.pfoot
  flex none
  box-sizing border-box
  padding clamp(36px, 5vw, 56px) clamp(16px, 4vw, 32px) 24px
  background-color PUB_BAR
  border-top 3px solid PUB_LEMON
  color PUB_WHITE
  font-family PUB_FONT_TEXT
  font-size 1rem
  line-height 1.55

.pfoot-grid
  display grid
  gap 32px
  grid-template-columns 1fr
  max-width PUB_MAX
  margin 0 auto
  padding-bottom 32px

.pfoot-name
  margin 0 0 8px
  color PUB_WHITE
  font-family PUB_FONT_DISPLAY
  font-size 1.6rem
  line-height 1.15

.pfoot-pitch
  max-width 40ch
  margin 0
  color PUB_ON_BAR
  font-family PUB_FONT_TEXT

h2
  margin 0 0 12px
  color PUB_WHITE
  font-family PUB_FONT_TEXT
  font-size 1rem
  font-weight 700

ul
  margin 0
  padding 0
  list-style none

li
  margin 0 0 8px
  padding 0

// Pas de soulignement (trop chargé sur fond sombre) : les liens se reconnaissent à leur blanc plus net que le texte courant,
// au chevron citron des listes et au surlignage citron au survol ou au clavier.
a
  color PUB_WHITE
  font-family PUB_FONT_TEXT
  font-weight 600
  text-decoration none
  transition background-color 0.15s ease
  &:hover, &:focus-visible
    background-color PUB_LEMON
    color PUB_INK

li a
  display inline-block
  &::before
    content '›'
    margin-right 0.5em
    color PUB_LEMON
    font-weight 700
  &:hover::before, &:focus-visible::before
    color PUB_INK

.pfoot-legal
  display flex
  flex-wrap wrap
  justify-content space-between
  gap 8px 24px
  max-width PUB_MAX
  margin 0 auto
  padding-top 20px
  border-top 1px solid rgba(255, 255, 255, 0.22)
  font-size 0.9rem
  p
    margin 0
    color PUB_ON_BAR
    font-family PUB_FONT_TEXT
  a
    font-weight 700

.peps
  color PUB_LEMON

@media (min-width: 576px)
  .pfoot-grid
    grid-template-columns 1fr 1fr

@media (min-width: 1000px)
  .pfoot-grid
    grid-template-columns 1.5fr 1fr 1fr
</style>
